// extracted by mini-css-extract-plugin
module.exports = {"container":"AdditionalInfo_container__4mjow","title":"AdditionalInfo_title__xBFea","text":"AdditionalInfo_text__cTiN2"};